<template>
    <pharmacists-dialog
        v-model="isOpen"
        title="Freiberufler Favoriten-Liste bearbeiten"
        :activePharmacists="activePharmacists"
        :savedPharmacistIds="favoriteIds"
        @save="submit"
        @remove="remove"
    />
</template>

<script>
import axios from "axios";
import { mapMutations } from 'vuex';
import PharmacistsDialog from "./PharmacistsDialog.vue";

export default {
    props: {
        value: Boolean,
        activePharmacists: Array,
        favoriteIds: Array,
        pharmacyId: String
    },
    components: {
        PharmacistsDialog
    },
    emits: ['get-pharmacists'],

    methods: {
        async submit(selectedPharmacistIds) {
            try {
                const response = await Promise.all(
                    selectedPharmacistIds.map(pharmacistId => {
                        return axios.post(`/pharmacies/${this.pharmacyId}/contractor_favorite`, {
                            freelancer_id: pharmacistId
                        })
                    })
                );
                if (response[0].data[1] == 200) this.alertSuccess(response[0].data[0].message);
                this.isOpen = false;
                this.$emit('get-pharmacists');
            } catch {
                this.alertError()
            }
        },
        async remove(pharmacistId) {
            try {
                const response = await axios.post(`/pharmacies/${this.pharmacyId}/contractor_favorite/remove`, {
                    freelancer_id: pharmacistId
                });
                if (response.data[1] == 200) this.alertSuccess(response.data[0].message)
                this.$emit('get-pharmacists');
            } catch {
                this.alertError()
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success'
        })
    },
    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state)
            }
        },
    },
}
</script>

<style scoped>
.list-group-item {
    padding: 8x 15px;
}
</style>
<style>
.v-select-list .v-list-item__action {
    margin-right: 1rem;
}
</style>
<style>
.favorite-search-dropdown {
    margin-top: 0.25rem;
}
.favorite-search-dropdown fieldset {
    display: none;
}
.favorite-search-dropdown .v-input__append-inner {
    position: absolute;
    top: 0.2rem;
    left: 10rem;
}
</style>
